<template>
  <tr>
    <td colspan="10">
      <blood-parasite
        v-if="itemComputed.title === 'Blood Parasite (BP)'"
        :test.sync="itemComputed"
      />
      <cross-matching
        v-if="itemComputed.title === 'Cross matching'"
        :test.sync="itemComputed"
      />
    </td>
  </tr>
</template>

<script>
  import BloodParasite from "./SpecificTest/BloodParasite";
  import CrossMatching from "./SpecificTest/CrossMatching";
  export default {
    name: "FixResult",
    components: {
      BloodParasite,
      CrossMatching
    },
    props: {
      test: {}
    },
    computed: {
      itemComputed: {
        get() {
          return this.test
        },
        set(val) {
          this.$emit('update:test', val)
        }
      }
    }
  }
</script>

<style scoped>

</style>
